/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_mobile_analytics_app_id": "731a8adac14b4751829b6055325208c1",
    "aws_mobile_analytics_app_region": "eu-west-2",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "731a8adac14b4751829b6055325208c1",
            "region": "eu-west-2"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://tx6zk4z4fnbrliujhsx7xkd7om.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cognito_identity_pool_id": "eu-west-2:97d68531-449a-4607-ac86-1ad51ef44da7",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_FEOY8Wtoc",
    "aws_user_pools_web_client_id": "3olqf0jgs7e07qh5m06iq7mrci",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "API": {
        "GraphQL": {
            "endpoint": "https://ydi3uahqqrawleemeo5djyikp4.appsync-api.eu-west-2.amazonaws.com/graphql",
            "region": "eu-west-2",
            "defaultAuthMode": "apiKey",
            "apiKey": "da2-7yduilgt5nb7rk5uffrrb5vohi"
        }
    }
};


export default awsmobile;
